import { getAuth } from 'firebase/auth'
import { useQuery } from '@tanstack/react-query'
import http from '../../utils/Http/Http'
import { User as FirebaseUser } from 'firebase/auth'
import { UserDataResponse } from './types'

export const getUserData = async (
	userId: string,
	include_ghl_connection: boolean = false,
): Promise<UserDataResponse> => {
	const includeGhlFlag = include_ghl_connection ? 'true' : 'false'
	const url = `/user/${userId}?include_ghl_flag=${includeGhlFlag}`
	const res = await http({
		url,
		method: 'GET',
	})

	return res.data
}

export default function useFetchUser(include_ghl_connection: boolean = false) {
	const auth = getAuth()
	const user = auth.currentUser as FirebaseUser

	const {
		data: userData,
		isFetching: fetchingUserData,
		refetch,
	} = useQuery({
		queryKey: ['user'],
		queryFn: () => getUserData(user.uid, include_ghl_connection),
	})

	return { userData, fetchingUserData, refetchUser: refetch }
}
